import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
interface LogoProps {
  variant?: 'full' | 'wordmark' | 'mark';
  className?: string;
  markClassName?: string;
}
export function Logo({
  variant = 'full',
  className = '',
  markClassName = ''
}: LogoProps) {
  const {
    brand
  } = useBrand();
  const isUpper = brand.wordmarkCase === 'upper';
  return <span className={`inline-flex items-center gap-2.5 ${className}`} data-id="element-37" data-mp="1rpe0dvqti7sv">
      {variant !== 'wordmark' && <Mark className={markClassName} data-id="element-38" data-mp="u1nh2zoiacgu" />}
      {variant !== 'mark' && <span className={`font-serif text-[1.35em] leading-none ${isUpper ? 'tracking-wordmark' : 'tracking-tight'}`} data-id="element-39" data-mp="yzf87rhbtujz">
          {brand.wordmark}
        </span>}
      <span className="sr-only" data-id="element-40" data-mp="18yeex4ij7g4c">{brand.name}</span>
    </span>;
}
export function Mark({
  className = ''
}: {
  className?: string;
}) {
  const {
    brand
  } = useBrand();
  if (brand.mark === 'flame') {
    // A single tended ember inside an open hearth arc. The arc is open, not a closed
    // ring — nothing about this transition is a finished circle.
    return <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-[1.2em] w-[1.2em] shrink-0 ${className}`} fill="none" data-id="element-41" data-mp="1ry79rc9ppcyv">
        <path d="M3.4 19.2A9.4 9.4 0 0 1 12 2.9a9.4 9.4 0 0 1 8.6 16.3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-42" data-mp="1nyop8hlsz3wk" />
        <path d="M12 8.1s2.6 2.3 2.6 5.1a2.6 2.6 0 1 1-5.2 0c0-1.2.6-2.2.6-2.2s.4 1 1.1 1.2c-.4-1.6 .9-4.1 .9-4.1Z" fill="currentColor" data-id="element-43" data-mp="1e0r0zu3y173y" />
      </svg>;
  }
  if (brand.mark === 'leaf') {
    return <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-[1.15em] w-[1.15em] shrink-0 ${className}`} fill="none" data-id="element-44" data-mp="107jay6vigjod">
        <path d="M4 20C4 11.7157 10.7157 5 19 5C19 13.2843 12.2843 20 4 20Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" data-id="element-45" data-mp="v7eom07x8uq8" />
        <path d="M4 20L14.5 9.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" data-id="element-46" data-mp="gjwlh6a0c85x" />
      </svg>;
  }
  return <svg viewBox="0 0 24 24" aria-hidden="true" className={`h-[1.1em] w-[1.1em] shrink-0 ${className}`} fill="none" data-id="element-47" data-mp="li7uxfwe4gnm">
      <circle cx="12" cy="12" r="9.4" stroke="currentColor" strokeWidth="1.6" strokeDasharray="25.5 4 25.5 4" transform="rotate(-42 12 12)" data-id="element-48" data-mp="bnftu23lnbo3" />
    </svg>;
}